import { eventCategory } from "@foretagsplatsen/yaem";
import commandInputWidgetBuilderVisitor from "../../../../accounting/document/command_visitors/commandInputWidgetBuilderVisitor.js";
import getNamedCommandHeading from "../getNamedCommandHeading.js";
import selection from "../selection.js";

/**
 * `abstractEntryCommand` is the abstract root of a Command Pattern
 * (http://en.wikipedia.org/wiki/Command_pattern).
 * In addition, there is a double dispatch used to render each action
 */

/**
 * TODO: write documentation
 */
export default class AbstractEntryCommand extends Object {
	constructor({ documentService }) {
		super(...arguments);

		this._entry = selection.firstEntry();
		this._documentService = documentService;

		this._root = this._documentService.getRoot();
		this._folder = this._documentService.getCurrentFolder();

		// TODO: add a copy of the current selection to be able to replay the
		// command later
		this._eventHandler = eventCategory();
		this.onRefresh = this._eventHandler.createEvent("refresh");
	}

	name() {
		return "";
	}

	getEntry() {
		return this._entry;
	}

	getFolder() {
		return this._folder;
	}

	getRoot() {
		return this._root;
	}

	getDocumentService() {
		return this._documentService;
	}

	accept(aVisitor) {
		return aVisitor.visitCommand(this);
	}

	priority() {
		return 1000;
	}

	// This is a hook because the only one knowing if the
	// action actually changes the state of the context is
	// the action itself

	requireRefresh() {
		return false;
	}

	// Entry point function to perform a command
	execute() {
		this._documentService.invoke(this);
	}

	perform() {
		const input = commandInputWidgetBuilderVisitor().visit(this);
		if (input === null) {
			this.doPerform();
		} else {
			input.show();
		}
	}

	doPerform() {
		this._performOnService(() => {
			if (this.requireRefresh()) {
				this._eventHandler.trigger("refresh");
			}
			this._postPerformHook();
		});

		this._execute();
	}

	heading() {
		return getNamedCommandHeading("Actions");
	}

	_performOnService(callback) {
		this._documentService.executeCommand(this, callback);
	}

	_postPerformHook() {}

	_execute() {}

	static isApplicable() {
		return false;
	}

	static shouldShowAdminCommands({ user }) {
		return user.canAdministrateDocumentArchive();
	}
}
